// extracted by mini-css-extract-plugin
export default {"cls1":"KFl0KDXjTdDXf2Zgbm2T","cls2":"V0bmQU0gTn0Fs1rwTuQ8 KFl0KDXjTdDXf2Zgbm2T"};